import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import { OperationOutcomeError, isUnauthenticated } from '@medplum/core';

function isTokenExpired(error: Error): boolean {
	return error instanceof OperationOutcomeError && isUnauthenticated(error.outcome);
}

function handleGlobalError(error: Error) {
	if (isTokenExpired(error)) {
		window.location.href = '/';
	}
}

export const queryClient = new QueryClient({
	queryCache: new QueryCache({ onError: handleGlobalError }),
	mutationCache: new MutationCache({ onError: handleGlobalError }),
	defaultOptions: {
		queries: {
			staleTime: 1000 * 10,
			gcTime: 1000 * 60 * 5,
			retry: (failureCount, error) => {
				if (isTokenExpired(error)) return false;
				return failureCount < 3;
			},
		},
	},
});
